export default {"src":"/_next/static/media/safari-pinned-tab.198dc28e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};